export default {
  multiContainers: `Algolia Places: 'container' must point to a single <input> element.
Example: instantiate the library twice if you want to bind two <inputs>.

See https://community.algolia.com/places/documentation.html#api-options-container`,
  badContainer: `Algolia Places: 'container' must point to an <input> element.

See https://community.algolia.com/places/documentation.html#api-options-container`,
  rateLimitReached: `Algolia Places: Current rate limit reached.

Sign up for a free 100,000 queries/month account at
https://www.algolia.com/users/sign_up/places.

Or upgrade your 100,000 queries/month plan by contacting us at
https://community.algolia.com/places/contact.html.`,
  invalidCredentials: `The APP ID or API key provided is invalid.`,
  invalidAppId: `Your APP ID is invalid. A Places APP ID starts with 'pl'. You must create a valid Places app first.

Create a free Places app here: https://www.algolia.com/users/sign_up/places`,
};
